import { select } from "utils/dynamic-helpers";
import { AlertWeight } from "services/user-patient-profile-weekly-report-activities";

export const SELECT_WEEKLY_REPORT_ITEM_FOR_REVIEW_SUBSCRIPTIONS = select(
    'id',
    `userPatientProfileWeeklyReportActivities
        .Where(a => a.alertSubscriptionDiff==${AlertWeight.GoodWeight} && a.reviewed==false)
        .Select(a => a.id) as activityIDs`,
)

export const SELECT_WEEKLY_REPORT_ITEM_FOR_REVIEW_NEW_SUBSCRIPTIONS = select(
    'id',
    `userPatientProfileWeeklyReportActivities
        .Where(a => a.alertNewSubscription==true && a.reviewed==false)
        .Select(a => a.id) as activityIDs`,
)
export const SELECT_WEEKLY_REPORT_ITEM_FOR_REVIEW_MAINTENANCE = select(
    'id',
    `userPatientProfileWeeklyReportActivities
        .Where(a => a.alertMaintenanceWeight && a.reviewed==false)
        .Select(a => a.id) as activityIDs`,
)

export const SELECT_WEEKLY_REPORT_ITEM = select(
    'id', 'reportDate', 'done',
    'userPatientProfileWeeklyReportActivities.count() as totalCount',
    `userPatientProfileWeeklyReportActivities.count((alertMoreThan10DaysWeighted==true||alertSubscriptionDiff!=${AlertWeight.GoodWeight})&&alertMaintenanceWeight!=true) as requiringAttentionCount`, // Patients requiring attention
    'userPatientProfileWeeklyReportActivities.count(a => a.alertMoreThan10DaysWeighted) as countNotWeighedInOver10Days',

    `userPatientProfileWeeklyReportActivities.count(a => a.alertMonthDiff == ${AlertWeight.SlowWeight}) as countMonthSlow`,
    `userPatientProfileWeeklyReportActivities.count(a => a.alertMonthDiff == ${AlertWeight.NotLosingWeight}) as countMonthNotLosingWeight`,

    `userPatientProfileWeeklyReportActivities.count(a => a.alertSubscriptionDiff == ${AlertWeight.SlowWeight}) as countSubscriptionSlow`,
    `userPatientProfileWeeklyReportActivities.count(a => a.alertSubscriptionDiff == ${AlertWeight.NotLosingWeight}) as countSubscriptionNotLosingWeight`,
    `userPatientProfileWeeklyReportActivities.count(a => a.alertNewSubscription) as countNewSubscription`,

    `userPatientProfileWeeklyReportActivities.count(a => a.alertMaintenanceWeight) as countMaintenanceWeight`,

    'userPatientProfileWeeklyReportActivities.count(a => a.reviewed) as reviewedCount',
    'userPatientProfileWeeklyReportActivities.count(a => a.highlight) as highlightCount',
)